import React from 'react';
import PropTypes from "prop-types";
import styled from 'styled-components';
import { device } from "../device";

const Block = styled.div`
    border: 1px solid #FF725C;
    border-radius: 16px;
    display: flex;
    margin: ${({space}) => 
        (space === 'Top' && '48px 0 0') ||
        (space === 'TopDown' && '48px 0') || 
        (space === 'Down' && '0 0 48px') || 
        '0'
    };
    padding: 24px 16px;
    width: 100%;
    @media ${device.sm} {
        padding: 24px;
    }
    @media ${device.md} {
        padding: 24px 40px;
    }
`;
const Icon = styled.div`
    font-size: 0;
    height: 24px;
    flex: 0 0 24px;
    max-width: 24px;
    margin-top: 1px;
    margin-right: 16px;
    width: 24px;
`;
const Text = styled.div`
    align-self: center;
`;

function BadGeneral({ children, ...props }) {
    return (
        <Block space={props.space}>
            <Icon>
                <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" clipRule="evenodd" d="M9.09 12L0 21.09 2.91 24 12 14.91 21.09 24 24 21.09 14.91 12 24 2.91 21.09 0 12 9.09 2.91 0 0 2.91 9.09 12z" fill="#EA5949"/></svg>
            </Icon>
            <Text>
                {children}
            </Text>
        </Block>
    )
}

BadGeneral.propTypes = {
    space: PropTypes.string
};

export default BadGeneral